import type { ApiV1DashboardStatisticsGet200ResponseStatistics } from './apiV1DashboardStatisticsGet200ResponseStatistics';

export interface ApiV1DashboardStatisticsGet200Response {
  message?: string;
  statistics?: ApiV1DashboardStatisticsGet200ResponseStatistics;
  success: boolean;
}
